import {getTargetContainers, getTargetContainerSyncHandler} from '../utility/target-sync';

const COMPONENT_NAME = "image-tabs";
const CLASS_SELECTOR = ".ImageTabContainer";
const CHILD_SELECTOR = ".ImageTab,[data-image-tab]";
const TARGET_CONTENT_SELECTOR = '[data-image-tab-target]';

const ACTIVE_CLASS = "is-active";

const instances = [];

function initialize(element, PageComponents) {
    const targetSelector = element.getAttribute("data-target");
    const childElements = element.querySelectorAll(CHILD_SELECTOR);
    const targetContentSelector = element.getAttribute("data-target-child-selector") || TARGET_CONTENT_SELECTOR;
    const contentElementList = getTargetContainers(targetSelector, targetContentSelector, childElements);

    let activeItemIndex = 0;

    function syncChildren(index) {
        childElements.forEach((child, i) => {
            child.classList.toggle(ACTIVE_CLASS, i === index);
        });
    }
    const syncTargets = getTargetContainerSyncHandler(contentElementList, ACTIVE_CLASS);

    function sync(index) {
        syncChildren(index);
        syncTargets(index);
        activeItemIndex = index;
    }

    childElements.forEach((child, index) => {
        if (child.classList.contains(ACTIVE_CLASS)) {
            activeItemIndex = index;
        }
        // Add desktop tab click handler
        child.addEventListener('click', (e) => {
            e.stopPropagation();
            sync(index);
        });
    });
    sync(activeItemIndex);

    instances.push({
        children: childElements,
        targets: contentElementList,
        sync
    });
}

export default {
    name: COMPONENT_NAME,
    instances,
    initialize
};
